import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import api from '@/utilities/api'
	import {
		Auth
	} from 'aws-amplify'

	// router
	import {
		useRoute,
		useRouter
	} from 'vue-router'

	// store
	import { 
		store as _systemStore
	} from '@/store/system'
	import { 
		store as _userStore
	} from '@/store/user'

	// types
	import { 
		CognitoUser
	} from '@aws-amplify/auth'

	// vue
	import {
		onBeforeMount
	} from 'vue'

	
	const __default__ = { name: 'AuthLayout' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// api
	const route = useRoute()
	const router = useRouter()

	const systemStore = _systemStore()
	const userStore = _userStore()

	onBeforeMount( async () => {
		try {
			// check for sign out
			if(route.name === "SignOut") {
				signOut()
				return
			}

			//check for existing login & reroute
			const user = await Auth.currentSession()
			let accessToken = user.getAccessToken()

			if(user && accessToken) {
				router.push({ name: systemStore.system.primaryRoute})
			}
		}
		catch(e) {
			console.error(e)
		}
	})

	async function signOut() {
		// sign out from FM
		const body = {
			action: "signOut"
		}
		await api("post", "fmDataAPI", "/fmDataAPI", body)

		// clear store
		userStore.user.cognitoUser = {} as CognitoUser
		systemStore.system.sidebarExpanded = true

		// sign out from cognito
		await Auth.signOut()

		router.push({ name: "SignIn" })
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("main", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})